import { IGetFiltroFolhaPagamentoUseCase } from "../../../presentation/useCases/read/get_filtro_folha_pagamento_use_case";
import { FiltroFolhaPagamento } from "../../models/filtro_folha_pagamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFiltroFolhaPagamentoUseCase
 */

export class GetFiltroFolhaPagamentoUseCase implements IGetFiltroFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFiltroFolhaPagamento(): Promise<FiltroFolhaPagamento | null> {
    return await this.repository.getFiltroFolhaPagamento();
  }
}
